var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},_vm._l((_vm.tiles),function(tile){return _c('tile',{key:tile})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }